import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-generic-confirmation-dialog',
    templateUrl: './generic-confirmation-dialog.component.html',
    styleUrls: ['./generic-confirmation-dialog.component.sass'],
    standalone: false
})
export class GenericConfirmationDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<GenericConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      title?: string;
      message: string;
      confirmButtonText: string;
      cancelButtonText?: string;
      cancelButtonStyle?: 'basic' | 'raised';
      cancelButtonColor?: 'primary' | 'warn' | 'accent';
      confirmButtonColor?: 'primary' | 'warn' | 'accent';
    }
  ) { }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
